<template>
<div id="topNavbar">
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
    :class="{
    }"
  >
    <div id="headerToolbar" class="md-toolbar-row">
      <div id="objectHeader" class="md-toolbar-section-start md-hide"></div>
      <div id="pageTitle" class="md-toolbar-section-start">
        <h1 class="md-title icon-color"><span class="topNavHead">{{ $route.name }}</span></h1>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>




        <div class="md-collapse">
          <md-button
            class="md-button md-just-icon md-round md-simple"
            @click="openSiteSearch()"
            title="Search"
          >
            <md-icon class="icon-color">search</md-icon>
          </md-button>
          <md-list>
            <md-list-item href="#/" title="Dashboard">
              <i class="material-icons icon-color">dashboard</i>
              <p class="hidden-lg hidden-md">Dashboard</p>
            </md-list-item>

            <li class="md-list-item" v-if="recentVisited">
              <a
                tabindex="0"
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
                title="Recently Visited"
              >
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon class="icon-color">query_builder</md-icon>
                      <p class="hidden-lg hidden-md">Recently Visited</p>
                    </md-button>
                    <ul class="recentlyVisited dropdown-menu dropdown-menu-right" v-if="recentVisited.length">
                      <li v-for="(_item, _index) in recentVisited" :key="_index">
                        <a :href="_item.link" :title="_item.title">
                          <md-icon class="_recentItem_icon" :class="_item.icon">{{_item.icon}}</md-icon>
                          <div class="_recentItem_title">{{ _item.title }}</div>
                        </a>
                      </li>
                    </ul>
                    <ul class="recentlyVisited dropdown-menu dropdown-menu-right" v-if="!recentVisited.length">
                      <li class="md-primary text-center">
                        <a href="#" title="No record found.">
                          <div class="_recentItem_title">No record found.</div>
                        </a>
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>
            
            <li class="md-list-item" v-if="$Session.user">
              <a
                tabindex="0"
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
                title="Notifications"
              >
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon class="icon-color">notifications</md-icon>
                      <span class="notification">{{ unreadNotifications.length }}</span>
                      <p class="hidden-lg hidden-md">Notifications</p>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right" v-if="latestNotifications.length">
                      <li v-for="(_item, _index) in latestNotifications" :key="_item.id">
                        <a :href="_item.link" class="_alertItem" title="Dismiss Alert">
                          <div class="_alertItem__container">
                            <div class="_alertItem__title">{{ _item.body | htmlToPlaintext }}</div>
                            <div class="_alertItem__title">{{ _item.subject }}</div>
                            <span class="_alertItem__timestamp">{{_item.createdAt | moment('M/D/YY hh:mm a') }}</span>
                            <span class="_alertItem__btn" @click.prevent="onAlertClose(_item, _index)">X</span>
                          </div>
                        </a>
                      </li>
                      <li v-if="hasMoreNotifications">
                        <router-link to="/dashboard" class="_alertItem">
                          <span class="_alertItem__title">View More</span>
                        </router-link>
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>

            <li class="md-list-item" v-if="$Session.user">
              <a
                href="#"
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
                title="My Account"
              >
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon class="icon-color">person</md-icon>
                      <!--<span class="notification"> text inside here will appear in bubble if shown </span>-->
                      <p class="hidden-lg hidden-md">My Account</p>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li><a href="#/pages/user">My Profile</a></li>
                      <li><a href="#">Settings</a></li>
                      <li><a href="#" v-on:click="$root.signOut()">Sign Out</a></li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>
            <!--
            <md-list-item href="#/pages/user">
              <i class="material-icons">person</i>
              <p class="hidden-lg hidden-md">Profile</p>
            </md-list-item>
            -->
            <md-list-item target="_blank" href="https://fortispayatlas.ideas.aha.io/ideas/new" title="Submit Idea">
              <i class="material-icons icon-color">wb_incandescent</i>
              <p class="hidden-lg hidden-md">Submit Idea</p>
            </md-list-item>

          </md-list>
        </div>
      </div>
    </div>
    
      <slot></slot>
    
  </md-toolbar>
  
</div>
</template>

<script>

import { API, graphqlOperation } from 'aws-amplify';
import _ from 'lodash';
import * as mutations from '@/graphql/mutations';
import * as queries from '@/graphql/queries';
import * as subscriptions from '@/graphql/subscriptions';
import gql from "graphql-tag";

export default {
  components: {},
  filters: {
    htmlToPlaintext: function (text) {
        return  text ? text == 'No Body' ? '' : (String(text).replace(/<[^>]+>/gm, '')).replace(/\&nbsp;/g, '').substring(0, 30) : '';
    }
  },
  data() {
    return {
      alertNotificationOptions: [],
      recentVisited: [],
    };
  },
  mounted() {
    this.subscribeToAlertNotifications();
    this.getStoredRecentVisited();
  },
  computed: {
    /**
     * Get all unread notifications sorted by createdAt field in descending order
     * @returns {Array} array of notification objects
     */
    unreadNotifications() {
      if (!this.$Session || !this.$Session.alerts || !this.$Session.alerts.length) {
        return [];
      }
      const notifications = _.sortBy(this.$Session.alerts, _alert => _alert.createdAt);
      return notifications.filter(_notification => {
        return _notification.status && 'unread' == _notification.status.toLowerCase();
      }).reverse();
    },
    /**
     * Get 5 recent notifications
     * @returns {Array} array of notification objects 
     */
    latestNotifications() {
      return this.unreadNotifications.slice(0, 5);
    },
    /**
     * A boolean value that indicates whether we have more than 5 notifcations
     * or not
     * @returns {boolean}
     */
    hasMoreNotifications() {
      return 5 < this.unreadNotifications.length;
    }
  },
  watch: {
    '$Session.recentVisited': {
      deep: true,
      immediate: true,
      handler: function() {
        if(this.$Session.recentVisited) {
          this.recentVisited = _.clone(this.$Session.recentVisited).reverse();
        }          
      }
    }
  },
  apollo: {
    subscriptions: {
      query: function() {
        return gql(queries['searchUsers']);
      },
      variables: {
        filter: { id: { eq: '-1' } },
        limit: 1,
      },
      update: () => [],
    }
  },
  methods: {
    getStoredRecentVisited() {
      let storedRecentVisited = JSON.parse(localStorage.getItem('recentVisited'));
      let recentVisited = [];
      let parsed = '';
      if(storedRecentVisited == null) {
        parsed = JSON.stringify(recentVisited);
        localStorage.setItem('recentVisited', parsed);
        this.$set(this.$Session,'recentVisited',recentVisited);
      } else {
        recentVisited = JSON.parse(localStorage.getItem('recentVisited'));
        this.$set(this.$Session,'recentVisited',recentVisited);
      }
    },
    openSiteSearch() {
      window.document.getElementById('mk-search-overlay').classList.add('mk-fullscreen-search-overlay-show');
      setTimeout(function () {
        window.document.getElementById('mk-fullscreen-search-input').focus();
      }, 100);
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    /**
     * Responsd to alert close event - Mark alert as read
     * @param {Object} alert - the alert object
     * @param {Int} index - the alert index
     * @returns {void}
     */
    onAlertClose(alert, index) {
      this.markAlertAsRead(alert.id)
        .then(response => {
          // 
        })
        .catch(err => {
          console.log('Error in GraphQL request while marking alert as read - ', err);
        });
    },
    /**
     * Mark an alert as read - perform GraphQL mutation
     * @param {String} id - the alert ID
     * @returns {Promise}
     */
    markAlertAsRead(id) {
      const input = { id, status: 'Read' };
      const request = graphqlOperation(mutations['updateAlert'], { input });
      return API.graphql(request);
    },
    /**
     * Subscribe to alerts notifications - update global $Session.alerts
     * @returns {void}
     */
    subscribeToAlertNotifications() {
      this.getAlertSubscriptions().forEach((_action, _index) => {
        const callback = this[_action.handler];
        const operation = subscriptions[_action.type];
        if (operation && !_action.subscription && callback && 'function' == typeof callback) {
          this.$apollo.queries.subscriptions.subscribeToMore({
            document: gql(subscriptions[_action.type]),
            updateQuery: (previousResult, { subscriptionData }) => {
              console.log('SUBSCRIPTION ', _action.type, subscriptionData);
              callback({ value: subscriptionData });
            },
          });
        }
      });
    },
    /**
     * Get configuration of all alert notification subscriptions 
     * each object has a type, a handler function to handle the event
     * and a subscription object which can be used to unsubscribe 
     * @returns {Array} - An array of objects with type, handler and subscription
     */
    getAlertSubscriptions() {
      this.alertNotificationOptions = [
        {
          type: 'onCreateAlert',
          handler: 'onCreateAlert',
          subscription: undefined,
        },
        {
          type: 'onUpdateAlert',
          handler: 'onUpdateAlert',
          subscription: undefined,
        },
        {
          type: 'onDeleteAlert',
          handler: 'onDeleteAlert',
          subscription: undefined,
        },
      ];
      return this.alertNotificationOptions;
    },
    /**
     * Handle create alert notification event
     * add the new alert to the global $Session.alerts
     * @param {Object} payload - the newly created alert
     * @returns {void}
     */
    onCreateAlert(payload) {
      const data = this.getNotificationEventData(payload, 'onCreateAlert');
      if (!data) {
        return;
      }
      if (!this.$Session && !this.$Session.alerts) {
        this.$Session.alerts = [];
      }
      const index = this.getAlertNotificationIndex(data);
      if (-1 == index) {
        this.$Session.alerts.push(data);
      } else {
        this.$set(this.$Session.alerts, index, data);
      }
    },
    /**
     * Handle update alert notification event
     * update the alert in the global $Session.alerts
     * @param {Object} payload - the newly created alert
     * @returns {void}
     */
    onUpdateAlert(payload) {
      const data = this.getNotificationEventData(payload, 'onUpdateAlert');
      if (!data) {
        return;
      }
      const index = this.getAlertNotificationIndex(data);
      if (-1 == index) {
        this.$Session.alerts.push(data);
      } else {
        this.$set(this.$Session.alerts, index, data);
      }
    },
    /**
     * Handle delete alert notification event
     * Find the alert in the global $Session.alerts and remove if found
     * @param {Object} payload - the alert to be removed
     * @returns {void}
     */
    onDeleteAlert(payload) {
      const data = this.getNotificationEventData(payload, 'onDeleteAlert');
      if (!data) {
        return;
      }
      const index = this.getAlertNotificationIndex(data);
      if (-1 != index) {
        this.$Session.alerts.splice(index, 1);
      }
    },
    /**
     * Check if payload data of a subscription event is valid or not
     * if valid then return it else return undefined
     * @param {Object} payload - event payload data
     * @param {String} key - the data key
     * @returns {Mixed} - object if found else undefined
     */
    getNotificationEventData(payload, key) {
      const data = this.$reduce(payload, `value.data.${key}`);
      const userId = this.$reduce(this.$Session, 'userId');
      if (
        data &&
        userId &&
        (userId == data.alertUserId || (data.user && data.user.id == userId))
      ) {
        return data;
      }
    },
    /**
     * Get alert notificaiton index in global $Session.alerts 
     * @param {Object} alert - the alert object to look for
     * @returns {Int} - if not found then -1 else 0 or more
     */
    getAlertNotificationIndex(alert) {
      if (!this.$Session || !this.$Session.alerts || !this.$Session.alerts.length) {
        return -1;
      }
      return this.$Session.alerts.findIndex(_alert => _alert.id == alert.id);
    },
  },
};
</script>

<style lang="scss" scoped>
  ._alertItem {
    position: relative;
  }
  ._alertItem__title {
    padding-right: 5px;
    font-weight: bold;
  }
  ._alertItem__btn {
    position: absolute;
    top: 50%;
    right: 2px;
    padding: 0 10px;
    border-radius: 2px;
    font-weight: bold;
    transition: background-color 0.15s, color 0.15s;
    transform: translateY(-50%);
    &:hover {
      background-color: rgba(#000, 0.15);
      color: #fff;
    }
  }

  ._alertItem__container {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-right: 10px;
  }

  ._alertItem__timestamp {
    align-self: flex-end;
  }
  
  ._recentItem_icon {
    padding-right: 20px;
  }
  ._recentItem_icon.styles {
    position: relative;
    right: -14px;
  }
  ._recentItem_title {
    padding-right: 5px;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .recentlyVisited.dropdown-menu {
    max-width: 300px;
    overflow-x: hidden;
  }
</style>